(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.toyCatalogListingView = {
    attach: function (context, settings) {
      // Initialize filters
      Drupal.behaviors.toyCatalogListingView.applyFilters('all');

      // Toggle filters dropdown
      $('.tc-filter--closed').click(function () {
        Drupal.behaviors.toyCatalogListingView.toggleFilters();
      });

      // Apply filters
      $('.tc-filter--option').click(function () {
        // GA event - filtering
        dataLayer.push({
          eventCategory: 'playcation- homepage',
          eventAction: 'filter',
          eventLabel: $(this).attr('value'),
          eventvalue: '',
          event: 'eventClick'
        });

        Drupal.behaviors.toyCatalogListingView.applyFilters($(this).attr('value'));
        $('.tc-filter--closed').text($(this).text());
        $('.tc-filter--option.selected').removeClass('selected');
        $(this).addClass('selected');
        Drupal.behaviors.toyCatalogListingView.toggleFilters();
      });

      // Close filters when clicking away.
      $(document).mouseup(function (e) {
        if ($(e.target).closest('.tc-filter').length === 0) {
          $('.tc-filter').removeClass('open');
        }
      });

      $(document).ready(function () {
        Drupal.behaviors.toyCatalogListingView.resize_background();
      });

      $(window).on('resize', function () {
        Drupal.behaviors.toyCatalogListingView.resize_background();
      });
    },

    resize_background: function () {
      var window_width = $(window).width();
      var target_width = (window_width < 768) ? 22 : 27;

      var remaining_width = window_width % target_width;
      var number_of_bricks = (window_width - remaining_width) / target_width;

      var new_brick_width = target_width + (remaining_width / number_of_bricks);
      var new_filters_width = number_of_bricks % 2 === 0 ? 432 : 405;
      if (window_width < 768) {
        new_filters_width = '100%';
      }

      $('.tc-filter--closed').css('width', new_filters_width);
      $('.tc-filter').css('background-size', new_brick_width);
    },

    toggleFilters: function () {
      $('.tc-filter').toggleClass('open');
    },

    applyFilters: function (filterValue) {
      // Reset filters
      $('.view-display-id-block_1.view-toy-catalog-destination-listing .tc-card').removeClass('row-reverse');
      $('.view-display-id-block_1.view-toy-catalog-destination-listing .views-row').removeAttr('hidden');

      if (filterValue === 'all') {
        // Set Color Pattern
        $('.view-display-id-block_1.view-toy-catalog-destination-listing .views-row:nth-child(3n - 2)').attr('color', 'red');
        $('.view-display-id-block_1.view-toy-catalog-destination-listing .views-row:nth-child(3n - 1)').attr('color', 'purple');
        $('.view-display-id-block_1.view-toy-catalog-destination-listing .views-row:nth-child(3n)').attr('color', 'blue');

        // Set alternating layout
        $('.view-display-id-block_1.view-toy-catalog-destination-listing .views-row:nth-child(even) .tc-card').addClass('row-reverse');
      }
      else {
        // Hide filtered destinations
        $('.node--toy-catalog-destination-page-teaser[data-location!=' + filterValue + ']').closest('.views-row').attr('hidden', '');
        $('.node--toy-catalog-destination-page-teaser[data-location=statewide]').closest('.views-row').removeAttr('hidden');

        // Loop over filtered list
        $('.view-display-id-block_1.view-toy-catalog-destination-listing .views-row:not([hidden])').each(function (i) {
          // Set alternating layout on filtered list
          if (i % 2 === 1) {
            $(this).find('.tc-card').addClass('row-reverse');
          }

          // Set Color Pattern on filtered list
          if (i === 0 || i % 3 === 0) {
            $(this).attr('color', 'red');
          }
          else if (i === 1 || i % 3 === 1) {
            $(this).attr('color', 'purple');
          }
          else if (i === 2 || i % 3 === 2) {
            $(this).attr('color', 'blue');
          }
        });
      }
    }
  };

})(jQuery, Drupal, drupalSettings);

